/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config";

const AboutTeam = () => {
  return (
    <motion.div
      variants={animation}
      className="py-6 xl:py-12 lg:py-12 bg-[#F5F5F5] bg-opacity-50 shadow-inner"
    >
      <div className="container">
        <h1 className="text-3xl xl:text-4xl lg:text-4xl font-roundo font-bold text-black leading-snug text-center">
          The Team Behind This Idea
        </h1>

        {/* TEAM */}
        <div className="mt-5 xl:mt-10 lg:mt-10">
          {/* SECTION ONE */}
          <div className="flex items-center justify-center">
            <div className="bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/rc-bhandari.jpg")}
                className="w-[30vh] rounded object-cover h-[35vh]"
                alt="Shri RC Bhandari"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Shri R.C. Bhandari
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Vice President
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION TWO */}
          <div className="mt-5 xl:mt-10 lg:mt-10 block xl:flex lg:flex items-center justify-center gap-y-10 xl:gap-10 lg:gap-10">
            {/* J B PATIL */}
            <div className="w-[30vh] mx-auto bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/jb-patil.jpg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Prof. Dr. J.B. Patil"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Prof. Dr. J.B. Patil
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Director
                  </p>
                </div>
              </div>
            </div>

            {/* P J DEORE */}
            <div className="w-[30vh] mx-auto mt-5 xl:mt-0 lg:mt-0 bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/pramod-deore.jpg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Prof. Dr. P.J. Deore"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Prof. Dr. P.J. Deore
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Dy. Director and Dean Academics
                  </p>
                </div>
              </div>
            </div>

            {/* THREE */}
            <div className="w-[30vh] mx-auto mt-5 xl:mt-0 lg:mt-0 bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/db-jadhav.jpg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Prof. Dr. J.B. Jadhav"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Prof. Dr. J.B. Jadhav
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Associate Professor
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION THREE */}
          <div className="mt-5 xl:mt-10 lg:mt-10 block xl:flex lg:flex items-center justify-center gap-y-10 xl:gap-10 lg:gap-10">
            {/* NIKHIL BHALKAR */}
            <div className="w-[30vh] mx-auto bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/nikhil-bhalkar.jpeg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Nikhil Bhalkar"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Nikhil Bhalkar
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Backend Developer Intern
                  </p>
                </div>
              </div>
            </div>

            {/* VISHAL BHALKAR */}
            <div className="w-[30vh] mx-auto mt-5 xl:mt-0 lg:mt-0 bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/vishal-bhalkar.jpeg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Vishal Bhalkar"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Vishal Bhalkar
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Frontend Developer Intern
                  </p>
                </div>
              </div>
            </div>

            {/* OM BHAGWAT */}
            <div className="w-[30vh] mx-auto mt-5 xl:mt-0 lg:mt-0 bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/om-bhagwat.jpeg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Om Bhagwat"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Om Bhagwat
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Frontend Developer Intern
                  </p>
                </div>
              </div>
            </div>

            {/* OM BHAGWAT */}
            <div className="w-[30vh] mx-auto mt-5 xl:mt-0 lg:mt-0 bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/bhupesh-chaudhari.jpg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Bhupesh Chaudhari"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Bhupesh Chaudhari
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Backend Developer Intern
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION FOUR */}
          <div className="mt-5 xl:mt-10 lg:mt-10 block xl:flex lg:flex items-center justify-center gap-y-10 xl:gap-10 lg:gap-10">
            {/* VIMAL PATEL */}
            <div className="w-[30vh] mx-auto bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/vimal-patel.jpeg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Mr Vimal Patel"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Mr Vimal Patel
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Co-founder
                  </p>
                </div>
              </div>
            </div>

            {/* ANJALI KAKKAD PATEL */}
            <div className="w-[30vh] mx-auto mt-5 xl:mt-0 lg:mt-0 bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/anjali-kakkad.jpeg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Mrs Anjali Kakkad Patel"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Mrs Anjali Kakkad Patel
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Co-founder
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION FIVE */}
          <div className="mt-5 xl:mt-10 lg:mt-10 block xl:flex lg:flex items-center justify-center gap-y-10 xl:gap-10 lg:gap-10">
            {/* DARSH SHAH */}
            <div className="w-[30vh] mx-auto bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/darsh-shah.jpeg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Mr Darsh Shah"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Mr Darsh Shah
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Frontend Developer
                  </p>
                </div>
              </div>
            </div>

            {/* ABHISHEK KUMAR */}
            <div className="w-[30vh] mx-auto mt-5 xl:mt-0 lg:mt-0 bg-white border border-[#E5E5E5] rounded-md p-2 shadow-md relative">
              <img
                src={require("../../assets/images/abhishek-kumar.jpeg")}
                className="w-full rounded object-cover h-[35vh]"
                alt="Mr Abhishek Kumar"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-end p-3">
                <div className="w-full shadow-md px-4 py-2 bg-white border border-[#E5E5E5] rounded-md">
                  <p className="text-md font-source font-semibold text-black">
                    Mr Abhishek Kumar
                  </p>
                  <p className="text-sm font-source font-regular text-greyText">
                    Fullstack developer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AboutTeam;
